import { ABOUT } from '../ids';
import { InstallLocation } from '../types';
import { formatDescription } from '../utils';
export const ids = ABOUT;
export const getDefinition = (staticsUrl, t) => ({
    ...ABOUT,
    installLocation: InstallLocation.Profile,
    method: 'addApplication',
    loginMenuTitle: 'Profile',
    showInLoginMenu: true,
    menuOrder: 1,
    social: true,
    socialHome: true,
    urlOverride: 'profile',
    uninstallable: true,
    page: {
        name: t('member-pages.about.name'),
        shortDescription: t('member-pages.about.short-description'),
        description: formatDescription({
            text: t('member-pages.about.description.text'),
            bulletPoints: [
                t('member-pages.about.description.bullet-point-1'),
                t('member-pages.about.description.bullet-point-2'),
                t('member-pages.about.description.bullet-point-3'),
                t('member-pages.about.description.bullet-point-4'),
                t('member-pages.about.description.bullet-point-5'),
            ],
        }),
        iconURL: `${staticsUrl}assets/images/icons/members-area-icon.svg`,
        origin: t('member-pages.about.origin'),
        screenshots: [
            `${staticsUrl}assets/images/about/profile.png`,
            `${staticsUrl}assets/images/about/mobile-profile.png`,
        ],
    },
});
//# sourceMappingURL=about.js.map